<template>
  <v-container
    id="event"
  >
    <app-city-header
      :payload="payload"
    >
    </app-city-header>

    <v-row>
      <v-col>
        <single-calendar></single-calendar>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import SingleCalendar from '@/components/calendar/SingleCalendar'
import { AppCityHeader } from '@/modules/city'

export default {
  components: {
    SingleCalendar,
    AppCityHeader
  },
  data () {
    return {
      payload: {
        municipioId: this.$route.params.id
      }
    }
  }
}
</script>
